import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("nv_token");
    if (!token) { setChecking(false); return; }
    api.get("/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => { localStorage.removeItem("nv_token"); })
      .finally(() => setChecking(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.require_2fa) {
      return { require_2fa: true, email: data.email };
    }
    localStorage.setItem("nv_token", data.token);
    setAdmin(data.user);
    return data.user;
  };

  const verify2FA = async (email, otp) => {
    const { data } = await api.post("/auth/verify-2fa", { email, otp });
    localStorage.setItem("nv_token", data.token);
    setAdmin(data.user);
    return data.user;
  };

  const resend2FA = async (email) => {
    const { data } = await api.post("/auth/resend-2fa", { email });
    return data;
  };

  const logout = () => { localStorage.removeItem("nv_token"); setAdmin(null); };

  return <AuthCtx.Provider value={{ admin, checking, login, verify2FA, resend2FA, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);

